export default {
  country: 'Land',
  language: 'Språk',
  currency: 'Valuta',
}
